/**
 * Formats kopecks (integer) to rubles string.
 * Example: 15000 -> "150 ₽"
 */
export function formatPrice(kopecks: number): string {
  const rubles = Math.floor(kopecks / 100);
  const remainder = kopecks % 100;

  if (remainder === 0) {
    return `${rubles} \u20BD`;
  }

  return `${rubles},${String(remainder).padStart(2, '0')} \u20BD`;
}

/**
 * Formats kopecks to rubles per month string.
 * Example: formatPricePerMonth(40000, 3) -> "~133 ₽/мес"
 */
export function formatPricePerMonth(kopecks: number, months: number): string {
  const rublesPerMonth = Math.round(kopecks / 100 / months);
  return `~${rublesPerMonth} \u20BD/мес`;
}
